import axios from "./axios";
import _axios from "axios";
import { other, admin, server, credentialImageUrl } from "./constants";

// ================================
// =  GET ImageBlob With Authen   =
// ================================

const getCredentialImageBlob = async (name) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await _axios.get(credentialImageUrl(name), {
        responseType: "blob",
        headers: { 'Authorization': `be ${accessToken}` },
    });
    return { data, status };
}

// ============================
// =  Route Manager Function  =
// ============================

const getRawRoute = async () => {
    var { data, status } = await axios.get(`${other.ROUTE_URL}?raw=true`);
    return data;
}

const addRoute = async (value) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.post(admin.ROUTE_URL, value, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const updateRoute = async (value) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.put(admin.ROUTE_URL, value, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const deleteRoute = async (value) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.delete(`${admin.ROUTE_URL}/${value}`, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

// ============================
// =  Users Manager Function  =
// ============================

const getUser = async (params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(admin.USER_LIST_URL, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const updateUserRole = async (users) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.put(admin.USER_ROLE_URL, { users }, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

// =======================================
// =  Store+Product GET/UPDATE Function  =
// =======================================

const getStore = async (params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(admin.STORE_MANAGER_URL, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;  
}

const updateStore = async (stores) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.put(admin.STORE_MANAGER_URL, { stores }, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const getProduct = async (params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(other.PRODUCT_URL, {
        params: {...params, admin: true},
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const updateProduct = async (products) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.put(admin.PRODUCT_MANAGER_URL, { products }, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

// ================================
// =  Report GET/UPDATE Function  =
// ================================

const getReportedProduct = async (params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(admin.REPORTED_PRODUCT_URL, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const updateReportedProduct = async (reports) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.put(admin.REPORTED_PRODUCT_URL, { reports }, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const getReportedStore = async (params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(admin.REPORTED_STORE_URL, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const updateReportedStore = async (reports) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.put(admin.REPORTED_STORE_URL, { reports }, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const getReportedUser = async (params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(admin.REPORTED_USER_URL, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const updateReportedUser = async (reports) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.put(admin.REPORTED_USER_URL, { reports }, {
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const getFeedback = async (params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(admin.FEEDBACK_URL, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

// ================================
// =            Stat              =
// ================================

const getViewStat = async (params, raw=false) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(raw ? admin.VIEWSTAT_RAW_URL : admin.VIEWSTAT_URL, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const getLogs = async (params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(admin.LOGS_URL, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

const getDocument = async (params) => {
    let accessToken = localStorage.getItem(server.ACCESS_TOKEN);
    var { data, status } = await axios.get(admin.COLLECTION_DOC_URL, {
        params,
        headers: { 'Authorization': `be ${accessToken}` }
    });
    return data;
}

export default {
    getCredentialImageBlob,
    getRawRoute,
    addRoute,
    updateRoute,
    deleteRoute,

    getUser,
    updateUserRole,

    getStore,
    updateStore,
    getProduct,
    updateProduct,

    getReportedProduct,
    updateReportedProduct,
    getReportedStore,
    updateReportedStore,
    getReportedUser,
    updateReportedUser,

    getFeedback,
    getViewStat,
    getLogs,
    getDocument
}